import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";
import React from "react";
import LpContractAndCivilLawLVMMeta from "./LVM/LpContractAndCivilLawLVMMeta.tsx";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import Layout from "../../Layouts/Layout.tsx";
import LandingPageTeaser from "../../../components/Teaser/LandingPageTeaser.tsx";
import LinkedCardBox from "../../../components/LinkedCardBox/LinkedCardBox.tsx";
import { defaultProvenExpertTeaserCard } from "@/src/services/landingPageService";
import iconAttorneys from "../../../assets/icons/generic/IconLawyers.tsx";
import iconDocument from "../../../assets/icons/generic/IconDocument.tsx";
import PartnerLogoSection from "../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection.tsx";
import Container from "../../../components/Container/Container.tsx";
import HowItWorksSectionConsulting from "../../../components/Sections/FamilyLaw/Consulting/HowItWorksSection/HowItWorksSectionConsulting.tsx";
import AttorneySection from "../../../components/Sections/Generic/AttorneySection/AttorneySection.tsx";
import ContractAndCivilLawConsultingCheckin from "../../../components/Checkin/MixedCheckin/Consulting/ContractAndCivilLawConsultingCheckin.tsx";

const getMetaDataByPartner = ({ partner }: { partner: string }) => {
  switch (partner) {
    case PARTNER_IRIS.LVM:
      return <LpContractAndCivilLawLVMMeta />;
    default:
      return null;
  }
};

const LpContractAndCivilLawPartner = ({ partner }: { partner: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  const { isLoggedIn } = useCustomer();
  const metaData = getMetaDataByPartner({ partner });

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      {metaData}
      <LandingPageTeaser
        teaserButtonText={"Jetzt starten"}
        headline={"Professionelle Hilfe im Vertrags- und Zivilrecht "}
        subheadline={"Kurz Anliegen schildern und Gespräch vereinbaren"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox
          linkedCards={[
            defaultProvenExpertTeaserCard,
            {
              icon: iconAttorneys,
              heading: "Professionelle Beratung",
            },
            {
              icon: iconDocument,
              heading: "Unkomplizierte Abwicklung",
            },
          ]}
        />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={partner} containerStyle={"settlementContainer"} />
      {!isLoggedIn && (
        <Container>
          <ContractAndCivilLawConsultingCheckin idPrefix={"top"} partner={partner} />
        </Container>
      )}
      <HowItWorksSectionConsulting />
      <AttorneySection
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <ContractAndCivilLawConsultingCheckin idPrefix={"top"} partner={partner} />
        </Container>
      )}
    </Layout>
  );
};

export default LpContractAndCivilLawPartner;
